<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label?: string;
    modelValue?: boolean | string[];
    value?: string;
    name?: string;
    id?: string;
    disabled?: boolean;
  }>(),
  {
    label: "",
    name: "",
    modelValue: false,
    id: () => uniqueId("form-check"),
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean | string[]): void;
}>();

const data = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue ?? false);
  },
});
</script>

<template>
  <div
    class="flex cursor-pointer flex-row items-center justify-start gap-2 py-1"
  >
    <input
      :id="id"
      v-model="data"
      type="checkbox"
      :value="value"
      class="checkbox"
      :name="name"
      :disabled="disabled"
    /><label
      :for="id"
      class="ml-2 flex flex-1 items-center gap-3"
      ><span class="label-text">{{ label }}</span>
      <span><slot /></span>
    </label>
  </div>
</template>

<style scoped lang="postcss">
.label-text {
  @apply text-base text-base-content;
}
.checkbox:not(:checked) {
  @apply bg-white;
}
.checkbox:checked {
  --chkfg: theme(colors.base-100);
}
</style>
